import { withPrefix } from "gatsby"
import React from "react"
import useSiteMetadata from "./SiteMetadata"

const PageHead = ({ title, description }) => {
  const { title: titleDefault, description: descriptionDefault } =
    useSiteMetadata()
  return (
    <>
      <html lang="en" />
      <title>{title || titleDefault} | Teamspective</title>
      <meta name="description" content={description || descriptionDefault} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${withPrefix("/")}img/apple-touch-icon.png`}
      />
      <link rel="icon" href={`${withPrefix("/")}favicon.ico`} sizes="48x48" />
      <link
        rel="icon"
        type="image/png"
        href={`${withPrefix("/")}img/favicon-32x32.png`}
        sizes="32x32"
      />
      <link
        rel="icon"
        type="image/png"
        href={`${withPrefix("/")}img/favicon-16x16.png`}
        sizes="16x16"
      />
      <link
        rel="icon"
        type="image/svg+xml"
        href={`${withPrefix("/")}img/favicon.svg`}
        sizes="any"
      />
      <meta name="theme-color" content="#fff" />

      <meta property="og:type" content="business.business" />

      <script
        type="text/javascript"
        async
        src="https://bot.leadoo.com/bot/dynamic.js?company=lJ28fjo9&mode=SPA"
      ></script>
    </>
  )
}

export default PageHead
